var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1170px",
    height: "353px",
    viewBox: "0 0 1170 353",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "885ABAFD-C332-431A-AD85-427739F6A233") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-2",
    transform: "translate(-135.000000, -2991.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info-Journey-02",
    transform: "translate(135.000000, 2991.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8179169,121 C70.1235372,120.139216 68.6395706,119.344647 67.1334553,118.627327 C66.5003007,118.332221 66.1940597,117.607439 66.4246951,116.949902 C66.889819,114.455837 65.7270094,113.407446 63.4346133,112.480448 C50.9980875,107.437138 38.6612312,102.184151 26.269003,97.030484 C25.4278478,96.7865767 24.8945557,95.9635669 25.0175983,95.0992384 C25.0175983,75.8456401 25.0175983,56.5920417 25.0175983,37.3384433 C25.0175983,36.1245175 25.1283421,35.68309 26.5015649,36.2348744 C31.0752827,38.2875125 35.7154468,40.1746153 40.3445365,42.0506824 C41.1421772,42.2698279 41.6536252,43.043758 41.5405693,43.8605354 C41.4851974,47.6237053 41.5405693,51.3979108 41.4851974,55.1721164 C41.3135965,56.5430147 41.787833,57.9159405 42.7698252,58.8911435 C42.9831924,59.1113723 43.1794078,59.347484 43.3567672,59.5974276 C45.1840394,61.8045654 45.5716426,61.8045654 47.9526338,60.149212 C48.5949476,59.6967488 48.5285014,59.1339287 48.5285014,58.5380015 C48.5285014,54.6644747 48.5285014,50.8130193 48.5285014,46.9174212 C48.5285014,45.648317 48.9161046,45.6262456 49.9127985,46.0456018 C56.911805,48.9884521 63.9255773,51.9313025 70.9541155,54.8741528 C71.6093797,55.0300464 72.0518622,55.6398525 71.9951069,56.3087923 C71.9951069,77.5929574 71.9951069,98.8808011 71.9951069,120.172323 C71.9286607,120.404073 71.8732888,120.569608 71.8179169,121 Z",
    id: "Path",
    fill: "#1AA8C7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0156101,82.7339374 C77.0156101,73.2445032 77.0156101,63.7660522 77.0156101,54.2876012 C76.889212,53.2805315 77.5424519,52.3383416 78.5385783,52.0909729 C91.1373424,46.8996081 103.754634,41.6752938 116.390453,36.4180301 C117.969004,35.7590417 117.980121,35.7480585 117.980121,37.3515972 C117.980121,56.5135178 117.980121,75.6827606 117.980121,94.8593255 C118.1109,95.7142593 117.584711,96.5338802 116.746183,96.7813752 C104.01402,102.060605 91.2929742,107.336174 78.5830445,112.608082 C77.0378432,113.256087 77.0156101,113.234121 77.0156101,111.509768 C77.008199,101.932469 77.008199,92.340525 77.0156101,82.7339374 Z",
    id: "Path",
    fill: "#1AA8C7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,37.4045744 C98.8248643,37.9817537 98.3213492,38.0483514 97.905402,38.2370446 L80.1619679,46.7393399 C78.1041236,47.7161049 76.0462793,48.6817703 74.0103269,49.7029337 C73.4065131,50.0738007 72.6558138,50.099035 72.0291045,49.7695313 C63.9217818,45.8476718 55.803513,41.9628111 47.6742983,38.114949 C46.754836,37.6820645 46.9190257,37.3157776 47.3240269,36.6609011 C52.4029618,28.3583986 59.7039307,23.2636812 69.2159876,22.2314182 C81.6068373,20.843968 91.3706517,25.7166933 98.2994573,36.272415 C98.6059447,36.6276023 98.7920264,37.027188 99,37.4045744 Z",
    id: "Path",
    fill: "#F18623",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5673241,0 C74.0251553,4.54255127 74.4440221,9.08510253 74.9602998,13.5254464 C75.086934,14.6610842 74.9602998,15.0699138 73.8400746,14.9904192 C71.8918568,14.8541426 71.8918568,14.9336373 72.0769375,12.7191435 C72.4763222,8.48321449 72.9244123,4.24728543 73.3530202,0 L73.5673241,0 Z",
    id: "Path",
    fill: "#F28B2C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2056528,15 L43.5929116,18.1898757 C45.5351876,19.6253198 47.4660385,21.0607639 49.4311649,22.4430433 C50.0138477,22.878993 50.2880513,23.1554489 49.5682667,23.7721582 C47.648841,25.4308936 47.6945416,25.4627923 46.0607447,23.538234 L39.7883356,16.2334186 C39.5027067,15.9037981 39.2627785,15.5529118 39,15.1701267 L39.2056528,15 Z",
    id: "Path",
    fill: "#F28B2C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,15.2767698 L99.8281617,25.6556391 C99.4939116,26.0707939 99.2749202,26.1169222 98.8023597,25.7594278 C96.4049798,23.9604238 96.3934539,23.9719559 98.8023597,22.0806953 L107.757957,15 L108,15.2767698 Z",
    id: "Path",
    fill: "#F28B2C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Gyanodaya",
    fill: "#1D1D1B",
    opacity: 0.75,
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontSize: 19,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 142
  }, "Gyanodaya")), /*#__PURE__*/React.createElement("text", {
    id: 50,
    fill: "#12427A",
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 30,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 231,
    y: 73
  }, "50")), /*#__PURE__*/React.createElement("text", {
    id: "10,000",
    fill: "#12427A",
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 30,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 330,
    y: 347
  }, "10,000")), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(437.000000, 43.000000)",
    fill: "#12427A"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Class",
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontSize: 27.47,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30.3043478
  }, "Class")), /*#__PURE__*/React.createElement("text", {
    id: "9th",
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 30,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 73.5215909,
    y: 30
  }, "9th")), /*#__PURE__*/React.createElement("text", {
    id: "&",
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontSize: 27.47,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 123.876136,
    y: 30.3043478
  }, "&amp;")), /*#__PURE__*/React.createElement("text", {
    id: "Class",
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontSize: 27.47,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.78977273,
    y: 63.3808696
  }, "Class")), /*#__PURE__*/React.createElement("text", {
    id: "10th",
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 30,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 77.3113636,
    y: 63.0765217
  }, "10th"))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#056B7B",
    fillRule: "nonzero",
    x: 0,
    y: 186,
    width: 1170,
    height: 67,
    rx: 30.63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1AA8C7",
    fillRule: "nonzero",
    x: 25,
    y: 202,
    width: 97,
    height: 37,
    rx: 7.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1636364,226.720339 C51.4290909,222.712024 54.44,219.881355 54.44,217.493653 C54.5269221,216.834042 54.3098915,216.170669 53.8488936,215.686882 C53.3878956,215.203096 52.7317532,214.950133 52.0618182,214.99791 C50.8766576,215.136223 49.8004029,215.74921 49.0836364,216.694151 L47,214.65218 C48.3611352,212.961288 50.4348663,211.98824 52.6181818,212.015984 C54.0880358,211.900641 55.537499,212.413552 56.6007396,213.425264 C57.6639802,214.436976 58.2394183,215.850831 58.1818182,217.309984 C58.1818182,220.108241 55.5418182,223.100971 52.7927273,225.953249 C53.6654545,225.856012 54.8327273,225.758776 55.6072727,225.758776 L59,225.758776 L59,229 L47.1636364,229 L47.1636364,226.720339 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,220.926738 C61,215.020664 63.3978202,212 67.0054496,212 C70.613079,212 73,215.043206 73,220.926738 C73,226.810269 70.613079,230 67.0054496,230 C63.3978202,230 61,226.82154 61,220.926738 Z M69.3269755,220.926738 C69.3269755,216.192862 68.3133515,215.099562 67.0054496,215.099562 C65.6975477,215.099562 64.6730245,216.226675 64.6730245,220.926738 C64.6730245,225.6268 65.6975477,226.889167 67.0054496,226.889167 C68.3133515,226.889167 69.3269755,225.649343 69.3269755,220.926738 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,225.818713 L78.7675841,225.818713 L78.7675841,215.987654 L75.5382263,215.987654 L75.5382263,213.546459 C77.05567,213.31465 78.5114777,212.78905 79.8216106,212 L82.7706422,212 L82.7706422,225.818713 L86,225.818713 L86,229 L75,229 L75,225.818713 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,225.256893 C87.0681544,223.375533 88.2079642,221.707563 89.9168207,220.98849 L89.9168207,220.886861 C88.5301688,219.999119 87.66923,218.466161 87.6210721,216.799131 C87.6210721,213.840608 89.9057301,212 93.077634,212 C96.2495379,212 98.2680222,213.874484 98.2680222,216.765255 C98.1870086,218.327551 97.3579811,219.749843 96.0499076,220.570683 L96.0499076,220.672312 C97.8211376,221.454972 98.9761373,223.22337 99,225.189141 C99,227.933114 96.5822551,229.999564 92.9556377,229.999564 C89.5730129,230.03344 87,228.091203 87,225.256893 Z M95.3179298,225.087512 C95.3179298,223.55179 93.8539741,222.964603 91.7134935,222.049945 C90.9149763,222.74404 90.4400193,223.748096 90.4048059,224.816502 C90.4199064,225.502946 90.7158966,226.151774 91.2213137,226.606337 C91.7267307,227.0609 92.3956403,227.279885 93.0665434,227.210422 C93.6572504,227.287001 94.2511859,227.095589 94.6910288,226.686886 C95.1308717,226.278183 95.3722404,225.693429 95.3512015,225.087512 L95.3179298,225.087512 Z M95.0961183,217.047556 C95.165592,216.455639 94.9748972,215.862683 94.5750251,215.427242 C94.175153,214.991801 93.6068876,214.758288 93.0221811,214.789142 C92.499356,214.760944 91.9902029,214.964917 91.6264284,215.348296 C91.2626539,215.731676 91.079992,216.256803 91.1256932,216.787839 C91.1256932,218.199348 92.3123845,218.876872 94.0536044,219.576981 C94.6882398,218.888714 95.0583078,217.990827 95.0961183,217.047556 L95.0961183,217.047556 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1AA8C7",
    fillRule: "nonzero",
    x: 601,
    y: 200,
    width: 97,
    height: 37,
    rx: 7.03
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.185623,224.752751 C628.454959,220.755241 631.468608,217.913767 631.468608,215.526065 C631.551486,214.867318 631.332857,214.206352 630.872392,213.723563 C630.411927,213.240775 629.757697,212.986568 629.088262,213.030322 C627.902023,213.168635 626.824789,213.781622 626.10737,214.726563 L624,212.65218 C625.362374,210.961288 627.437992,209.98824 629.623294,210.015984 C631.094485,209.900641 632.545267,210.413552 633.609476,211.425264 C634.673684,212.436976 635.249645,213.850831 635.191993,215.309984 C635.191993,218.119045 632.549591,221.100971 629.797998,223.953249 C630.660601,223.856012 631.839854,223.758776 632.615105,223.758776 L636,223.758776 L636,227 L624.185623,227 L624.185623,224.752751 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637,218.926738 C637,213.020664 639.39782,210 643.00545,210 C646.613079,210 649,213.043206 649,218.926738 C649,224.810269 646.60218,228 643.00545,228 C639.408719,228 637,224.82154 637,218.926738 Z M645.326975,218.926738 C645.326975,214.192862 644.313351,213.110833 643.00545,213.110833 C641.697548,213.110833 640.673025,214.237946 640.673025,218.926738 C640.673025,223.615529 641.697548,224.900438 643.00545,224.900438 C644.313351,224.900438 645.326975,223.660614 645.326975,218.926738 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.185623,224.752751 C654.465878,220.755241 657.479527,217.913767 657.479527,215.526065 C657.562405,214.867318 657.343776,214.206352 656.883311,213.723563 C656.422846,213.240775 655.768616,212.986568 655.099181,213.030322 C653.909005,213.165802 652.827321,213.779074 652.10737,214.726563 L650,212.65218 C651.366838,210.960896 653.445816,209.988162 655.634213,210.015984 C657.105404,209.900641 658.556186,210.413552 659.620395,211.425264 C660.684603,212.436976 661.260564,213.850831 661.202912,215.309984 C661.202912,218.119045 658.56051,221.100971 655.808917,223.953249 C656.67152,223.856012 657.839854,223.758776 658.626024,223.758776 L662,223.758776 L662,227 L650.185623,227 L650.185623,224.752751 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663,218.926738 C663,213.020664 665.39782,210 669.00545,210 C672.613079,210 675,213.043206 675,218.926738 C675,224.810269 672.60218,228 669.00545,228 C665.408719,228 663,224.82154 663,218.926738 Z M671.326975,218.926738 C671.326975,214.192862 670.313351,213.110833 669.00545,213.110833 C667.697548,213.110833 666.673025,214.237946 666.673025,218.926738 C666.673025,223.615529 667.697548,224.900438 669.00545,224.900438 C670.313351,224.900438 671.326975,223.660614 671.326975,218.926738 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#056B7B",
    fillRule: "nonzero",
    x: 235,
    y: 124,
    width: 24,
    height: 124,
    rx: 8.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#056B7B",
    fillRule: "nonzero",
    x: 368,
    y: 190,
    width: 24,
    height: 124,
    rx: 8.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#056B7B",
    fillRule: "nonzero",
    x: 503,
    y: 124,
    width: 24,
    height: 124,
    rx: 8.55
  }), /*#__PURE__*/React.createElement("text", {
    id: "250+",
    fill: "#12427A",
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 30,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 734,
    y: 73
  }, "250+")), /*#__PURE__*/React.createElement("text", {
    id: "30,000+",
    fill: "#12427A",
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 30,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 842,
    y: 347
  }, "30,000+")), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(953.000000, 10.000000)",
    fill: "#12427A"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Class",
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontSize: 27.47,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1.1048951,
    y: 30.3030303
  }, "Class")), /*#__PURE__*/React.createElement("text", {
    id: "6th",
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 30,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 75.0555245,
    y: 30
  }, "6th")), /*#__PURE__*/React.createElement("text", {
    id: "to",
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontSize: 27.47,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 125.703916,
    y: 30.3030303
  }, "to")), /*#__PURE__*/React.createElement("text", {
    id: "Class",
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontSize: 27.47,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.60741259,
    y: 63.3663636
  }, "Class")), /*#__PURE__*/React.createElement("text", {
    id: "12th",
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 30,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 78.558042,
    y: 63.0633333
  }, "12th")), /*#__PURE__*/React.createElement("text", {
    id: ",",
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontSize: 27.47,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 147.172028,
    y: 63.3663636
  }, ",")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 66.060606)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "JEE",
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 27.47,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.0662937063,
    y: 30.3690909
  }, "JEE")), /*#__PURE__*/React.createElement("text", {
    id: "&",
    fontFamily: "SourceSansPro-Black, Source Sans Pro",
    fontSize: 27.47,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 49.7644755,
    y: 30.3690909
  }, "&amp;")), /*#__PURE__*/React.createElement("text", {
    id: "NEET",
    fontFamily: "SourceSansPro-Regular, Source Sans Pro",
    fontSize: 30,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 75.3538462,
    y: 30.0660606
  }, "NEET")))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#056B7B",
    fillRule: "nonzero",
    x: 756,
    y: 124,
    width: 24,
    height: 124,
    rx: 8.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#056B7B",
    fillRule: "nonzero",
    x: 889,
    y: 190,
    width: 24,
    height: 124,
    rx: 8.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#056B7B",
    fillRule: "nonzero",
    x: 1024,
    y: 124,
    width: 24,
    height: 124,
    rx: 8.55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132,
    y1: 217.5,
    x2: 582,
    y2: 217.5,
    id: "Path",
    stroke: "#F9B233",
    strokeWidth: 2,
    strokeDasharray: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 709,
    y1: 217.5,
    x2: 1159,
    y2: 217.5,
    id: "Path",
    stroke: "#F9B233",
    strokeWidth: 2,
    strokeDasharray: 8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.c08e52c1dcb97eb19df9043ee16ba327.svg";
export { ForwardRef as ReactComponent };